import { useTranslation } from "react-i18next";
import PostsBase from "../component/sharedComponents/PostsBase";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTrendingPosts } from "../slices/2-post/thunk";
import SectionLoader from "../component/sharedComponents/Loading/SectionLoader";

const TrendingPage = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const { trendingPosts, pagination, loading } = useSelector((state) => state.posts)
    const [isFetchingMore, setIsFetchingMore] = useState(false);
    const paginationRef = useRef(pagination);
    useEffect(() => {
        dispatch(getTrendingPosts({ limit: 6, page: 1, isTrending: 1 }))
    }, [dispatch])


    // keep ref updated
    useEffect(() => {
        paginationRef.current = pagination;
    }, [pagination]);


    useEffect(() => {
        const handleScroll = () => {
            if (!pagination?.hasNextPage || isFetchingMore) return;

            const scrollTop = window.scrollY || document.documentElement.scrollTop;
            const windowHeight = window.innerHeight;
            const docHeight = document.documentElement.scrollHeight;

            if (scrollTop + windowHeight >= docHeight * 0.9) {
                setIsFetchingMore(true);

                dispatch(
                    getTrendingPosts({
                        limit: 6,
                        page: pagination.nextPage,
                        isTrending: 1
                    })
                ).finally(() => {
                    setIsFetchingMore(false);
                });
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [dispatch, pagination, isFetchingMore]);


    if (loading && trendingPosts.length === 0) {
        return <SectionLoader />;
    }
    // console.log(pagination)
    // console.log(trendingPosts)
    return (
        <div className="max-w-2xl mx-auto space-y-4">
            <div
                className={`flex  flex-col  justify-between `}
            >
                <h2 className="text-xl font-bold text-gray-900 dark:text-gray-100">
                    {t("topposts")}
                </h2>
                <div className="mt-6">
                    <>
                        <PostsBase posts={trendingPosts} />
                        {isFetchingMore && <SectionLoader />}
                    </>
                </div>
            </div>
        </div>
    );
};

export default TrendingPage;
